module.exports = __webpack_public_path__ + "static/images/callout_3.c3039470ecb807e9070f468b85ca725b.jpg";